// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mcdBa","content":"styles_content__2jSaf","row":"styles_row__2U8Op","footer":"styles_footer__2lY3_","phraseLength":"styles_phraseLength__19rKM"};